import { action } from '@storybook/addon-actions';
import type { Meta, StoryObj } from '@storybook/react';

import { Sparcles } from './Sparcles';

const meta: Meta<typeof Sparcles> = {
  title: 'parts/Sparcles',
  component: Sparcles,
  args: {},
  tags: ['autodocs'],
};

export default meta;

type Story = StoryObj<typeof Sparcles>;

export const Basic: Story = {
  args: {
    onClick: action('clicked'),
  },
};
